// @ts-nocheck
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { useTableBoundary } from '../context/TableSchemaBuilderContext';

const TableEventBoundary = ({ children }) => {
  const boundaryRef = useTableBoundary();

  const handleFocus = useCallback(
    (e) => {
      if (!boundaryRef.current?.contains(e.target)) {
        return;
      }
      e.stopPropagation();
    },
    [boundaryRef]
  );

  return (
    <Box
      ref={boundaryRef}
      onFocus={handleFocus}
      sx={{
        isolation: 'isolate',
      }}
      tabIndex="-1"
    >
      {children}
    </Box>
  );
};

TableEventBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TableEventBoundary;
